import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import Hidden from '@material-ui/core/Hidden';
import LinearProgress from '@material-ui/core/LinearProgress';
import actions from '../actions';
import Routes from './routes';
import Header from './components/Header';
import HeaderMenu from './components/HeaderMenu';
import Drawer from './components/Drawer';
import DrawerList from './components/DrawerList';
import FooterText from './components/FooterText';
import Language from './screens/Language';
import config from '../config';
import * as Constant from '../constants/actionTypes';
import techConfig from '../techConfig';
import {
  capitalizeSecondLetter,
  firstLowerLetter,
  labelName,
  onAddInertToDrawer,
} from './UtilsWeb';
import styleConfig from './muiTheme';
import './App.css';

class App extends PureComponent {
  static contextTypes = {
    router: PropTypes.object,
  };

  static propTypes = {
    actions: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
    intl: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      isLanguage: false,
      isReady: false,
      isBrowserSupport: false,
    };
  }

  componentDidMount() {
    sessionStorage.removeItem(Constant.OPT_IN_MESSAGE_KEY);
    const { actions: actionCall } = this.props;
    actionCall.reset();
    import('../config.json').then(data => {
      const finalConfig = { ...techConfig, ...data };
      for (const [key, value] of Object.entries(finalConfig)) {
        config[key] = value;
      }
      this.setState({ isReady: true });
    });
    this.getBrowser();
    // console.warn('Testing :: To be called');
    // window.addEventListener(Constant.STORAGE, this.localStorageChangeEvents);

    // eslint-disable-next-line no-underscore-dangle
    window.__webpack_nonce__ = 'B4Q2OFhkN2EtMmRkYi00MTExLWFhM2YtNDhkNTc4NGJhMjA9';
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isAuthenticated === nextProps.isAuthenticated) {
      this.setState({ isOpen: false });
    }
  }

  // componentWillUnmount() {
  //   document.removeEventListener(Constant.STORAGE, this.localStorageChangeEvents);
  // }

  // localStorageChangeEvents = event => {
  //   console.warn('Testing ::', event);
  //   if (
  //     event.oldValue &&
  //     event.newValue &&
  //     event.oldValue.includes(Constant.USER) &&
  //     event.oldValue.includes(Constant.USER_LOGIN)
  //   ) {
  //     const oldVal = JSON.parse(event.oldValue);
  //     const newVal = JSON.parse(event.newValue);
  //     if (
  //       oldVal.user &&
  //       oldVal.login &&
  //       oldVal.user !== newVal.user &&
  //       oldVal.login !== newVal.login &&
  //       newVal.user === Constant.NULL &&
  //       newVal.login === Constant.NULL
  //     ) {
  //       const { actions: actionCall } = this.props;
  //       actionCall.reset();
  //     }
  //   }
  // };

  redirect = route => {
    if (route === `${Constant.SLASH}${firstLowerLetter(Constant.LOGOUT_LINK)}`) {
      sessionStorage.removeItem(Constant.OPT_IN_MESSAGE_KEY);
      const { actions: actionCall } = this.props;
      actionCall.reset();
      onAddInertToDrawer('accessibility-keyboard-testing', 'remove');
      onAddInertToDrawer('provider-card-template', 'remove');
    } else if (route === `${Constant.SLASH}${firstLowerLetter(Constant.LANGUAGE_LINK)}`) {
      this.setState({ isLanguage: true });
    } else {
      const { history } = this.props;
      history.push(route);
    }
  };

  toggleDrawer = isOpen => {
    if (isOpen) {
      onAddInertToDrawer('accessibility-keyboard-testing', 'add');
    } else {
      onAddInertToDrawer('accessibility-keyboard-testing', 'remove');
    }
    this.setState({ isOpen });
  };

  getBrowser = () => {
    const { userAgent } = navigator;
    let tem;
    let M = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return { name: Constant.IE, version: tem[1] || '' };
    }

    if (M[1] === Constant.CHROME) {
      tem = userAgent.match(/\bOPR|Edge\/(\d+)/);
      if (tem != null) {
        return { name: Constant.OPERA, version: tem[1] };
      }
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

    const tem1 = userAgent.match(/version\/(\d+)/i);

    if (tem1 !== null) {
      M.splice(1, 1, tem1[1]);
    }
    switch (M[0]) {
      case Constant.CHROME:
      case Constant.SAFARI:
        this.setState({ isBrowserSupport: true });
        break;
      default:
        break;
    }
    return null;
  };

  render() {
    const {
      isAuthenticated,
      location: { pathname },
      auth,
      user: { user },
      locale,
      intl,
    } = this.props;
    const { isOpen, isReady, isBrowserSupport, isLanguage } = this.state;
    if (!isReady) {
      return <LinearProgress />;
    }

    // NOTE: Will change the appropriate text later for Card and Health information.
    let title = intl.formatMessage({ id: Constant.HEADER_FETCHED_INFO });

    switch (capitalizeSecondLetter(pathname)) {
      case `${Constant.SLASH}${Constant.PROVIDER_SEARCH_LINK}`:
        title = `${intl.formatMessage({ id: Constant.LABEL_MY_PROVIDER })}`;
        document.title = title;
        break;
      case `${Constant.SLASH}${Constant.DIGITAL_CARD_LINK}`:
        title = `${intl.formatMessage({ id: Constant.LABEL_DIGITAL_CARD })}`;
        document.title = title;
        break;
      case `${Constant.SLASH}`:
        title = `${intl.formatMessage({ id: Constant.LABEL_PROVIDER_LOGIN_TITLE })}`;
        // title = `${intl.formatMessage({ id: Constant.LABEL_LOGIN })}`;
        document.title = title;
        break;
      case `${Constant.SLASH}${Constant.PROVIDER_LOGIN_LINK}`:
        title = `${intl.formatMessage({ id: Constant.LABEL_PROVIDER_LOGIN_TITLE })}`;
        document.title = title;
        break;
      default:
        break;
    }

    const appTitle = `${intl
      .formatMessage({ id: Constant.LABEL_APP_TITLE })
      .replace(Constant.APP_NAME, `${techConfig.choosePreferredAppName}`)}`;

    return (
      <div className="App container" id="accessibility-keyboard-testing">
        {(isAuthenticated &&
          !pathname.includes(
            `${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_LOGIN_LINK)}`,
          )) ||
        pathname.includes(`${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_CARD_LINK)}`) ? (
          <HeaderMenu
            toggleDrawer={this.toggleDrawer}
            title={title}
            appTitle={appTitle}
            isOpen={this.state.isOpen}
          />
        ) : (
          <Header appTitle={appTitle} />
        )}
        {(isAuthenticated ||
          pathname.includes(
            `${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_CARD_LINK)}`,
          )) && (
          <Drawer
            open={isOpen}
            toggleDrawer={d => this.toggleDrawer(d)}
            user={user}
            redirect={this.redirect}
            route={pathname}
            auth={auth}
          />
        )}
        <Hidden smDown>
          {(isAuthenticated ||
            pathname.includes(
              `${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_CARD_LINK)}`,
            )) &&
            pathname !== `${Constant.SLASH}${firstLowerLetter(Constant.HOME_LINK)}` &&
            pathname !== `${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_LOGIN_LINK)}` && (
              <div
                id="toolBar"
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: 88,
                  height: '100vh',
                  backgroundColor: styleConfig.palette.white,
                  padding: '80px 0 0 0',
                  margin: 0,
                  display: 'flex',
                  justifyContent: 'center',
                  boxShadow: `1px 0px 5px 0px ${styleConfig.palette.gray.gray6A}`,
                  opacity: !this.toggleDrawer === isOpen ? 1 : 0,
                }}
              >
                <DrawerList
                  redirect={this.redirect}
                  route={pathname}
                  user={user}
                  auth={auth}
                  onlyIcons
                  toggleDrawer={d => this.toggleDrawer(d)}
                  locale={locale}
                />
              </div>
            )}
        </Hidden>
        <Routes isAuthenticated={isAuthenticated} locale={locale} user={user} />
        <Language open={isLanguage} toggle={() => this.setState({ isLanguage: false })} />
        {((!isBrowserSupport && !isAuthenticated) ||
          (!isBrowserSupport &&
            pathname === `${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_LOGIN_LINK)}`)) && (
          <div
            style={{
              height: 50,
              backgroundColor: styleConfig.palette.whiteOpacity8,
              padding: 10,
              position: 'absolute',
              bottom: 0,
              color: styleConfig.palette.red.red3,
              fontSize: 18,
              width: '100%',
              boxShadow: `-1px -1px 3px ${styleConfig.palette.gray.grayC}`,
            }}
          >
            <marquee scrollamount={Constant.SCROLL_AMOUNT}>
              {labelName(Constant.LABEL_BROWSER_NOT_SUPPORT)}
            </marquee>
          </div>
        )}
        {techConfig.DisplayWebPageFooter && <FooterText />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    auth,
    user,
    locale: { locale },
    alerts,
    broadcast,
    providerLogin,
  } = state;
  return {
    isAuthenticated: !!providerLogin.data && !providerLogin.error,
    auth,
    user,
    locale,
    alerts,
    broadcast,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(App)));
